import { isArray } from 'lodash';
var serviceTypeBanner = function serviceTypeBanner(serviceTypes) {
  if (!isArray(serviceTypes)) {
    return serviceTypes.name;
  }
  var firstSTName = serviceTypes[0] && serviceTypes[0].name;
  return serviceTypes.length > 1 ? "\n    ".concat(firstSTName, " and ").concat(serviceTypes.length - 1, " more\n  ") : firstSTName;
};
export default serviceTypeBanner;